import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { catchError, throwError } from 'rxjs';

import { ApiResponse } from '../interfaces/CommonInterfaces';
import { ToastService } from '../toast-alert/toast.service';
import { EnvironmentService } from '../../services/environment.service';

export const apiInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const env = inject(EnvironmentService);
  const isManagedHost =
    req.url.startsWith(env.supergodUrl) ||
    req.url.startsWith(env.bhiveUrl) ||
    req.url.startsWith(env.borServiceUrl);
  if (!isManagedHost) {
    return next(req);
  }

  const toast = inject(ToastService);
  const router = inject(Router);
  const keycloak = inject(Keycloak);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const apiError = error.error as ApiResponse<unknown> | null;

      switch (error.status) {
        case 400:
          apiError?.errors?.forEach((e) => toast.error(`${e.field}: ${e.message}`));
          break;
        case 401:
          router.navigate(['/login']);
          break;
        case 403:
          toast.error('Access denied — signing you out.', true);
          void keycloak.logout({ redirectUri: `${window.location.origin}/login` });
          break;
        case 404:
          toast.warn(apiError?.message ?? 'Not found');
          break;
        case 500:
          toast.error('Something went wrong. Please try again.');
          break;
        default:
          toast.error(apiError?.message ?? 'Unknown error');
      }

      return throwError(() => apiError ?? error);
    })
  );
};
